import React from 'react'
import CorporateLogo from './CorporateLogo'
import urls from '@/utils/urls/urls'
import cl from '@/utils/console/cl'

const CorporateLogoContainer = async () => {
    const corporateLogoRes = await fetch(urls?.corporateLogo, {
        cache: "no-store"
    })
    const corporateLogoData = await corporateLogoRes.json()
    const corporateLogo =   Array.isArray(corporateLogoData?.data) ? corporateLogoData?.data : [];
    // cl("corporateLogoData", corporateLogo)
  return (
    <CorporateLogo corporateLogo={corporateLogo} />
  )
}

export default CorporateLogoContainer
